<template>
  <appCdialog
    ref="cDialog"
    v-bind="$attrs"
    top="10vh"
    :title="appItem.id ? '编辑应用分类' : '添加应用分类'"
    v-on="$listeners"
    width="490px"
  >
  <div class="app-type">
    <div class="app-type-input">
      <span class="input-label">应用分类名称</span>
      <span class="input-name">
        <el-input v-model="appName" class="currency-input-30" placeholder="请输入应用分类名称"></el-input>
      </span>
    </div>
    <div class="app-type-btn">
      <el-button @click="sureAddType" class="curr-36"> 确定 </el-button>
      <el-button @click="closeSchedule" class="cancle-36"> 取消 </el-button>
    </div>
  </div>
  </appCdialog>
</template>

<script>
import appCdialog from "@/components/sys/dialog/dialog.vue";
export default {
  components: {
    appCdialog,
  },
  props: {
    appItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      appName: ''
    }
  },
  created() {
    this.appName = this.appItem.name
  },
  methods: {
    /** 关闭 */
    closeSchedule() {
      this.$refs.cDialog.handleClose();
    },
    sureAddType() {

    }
  }
};
</script>

<style lang="less" scoped>
  .app-type {
    height: 140px;
    padding: 20px;
    &-btn {
      height: 36px;
      line-height: 36px;
      text-align: right;
      margin: 22px 0;
    }
    &-input {
      display: flex;
      align-items: center;
      height: 40px;
      .input-label {
        width: 100px;
        color: #072039;
      }
      .input-name {
        flex: 1;
      }
    }
  }
</style>